/* CLEËMEDIC · Carruseles: deslizar con el dedo (nativo) y arrastrar con el mouse */
(function () {
  if (window.__cmDrag) return;
  window.__cmDrag = true;
  var st = null;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    var el = e.target.closest && e.target.closest('[data-cm-drag]');
    if (!el || el.scrollWidth <= el.clientWidth + 2) return;
    st = { el: el, x: e.clientX, left: el.scrollLeft, moved: false };
  });
  document.addEventListener('pointermove', function (e) {
    if (!st) return;
    var dx = e.clientX - st.x;
    if (!st.moved && Math.abs(dx) < 6) return;
    if (!st.moved) { st.moved = true; st.el.classList.add('is-dragging'); }
    st.el.scrollLeft = st.left - dx;
    e.preventDefault();
  });
  function end() {
    if (!st) return;
    var el = st.el, moved = st.moved;
    st = null;
    if (moved) {
      el.classList.remove('is-dragging');
      el.__cmBlock = true;
      setTimeout(function () { el.__cmBlock = false; }, 60);
    }
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('[data-cm-drag]');
    if (el && el.__cmBlock) { e.preventDefault(); e.stopPropagation(); }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[data-cm-drag]')) e.preventDefault();
  });
})();
